import { MatDialog } from "@angular/material/dialog";
import {
  UpgradePlanDialogComponent,
  UpgradePlanDialogData,
} from "src/app/pages/upgrade-plan-dialog/upgrade-plan-dialog.component";
import { isCreatorPlanUser } from "./plan.util";

/** Creator plan may only publish public paid flows/bundles. */
export function requiresCreatorPublicPaidPublish(user?: any): boolean {
  return isCreatorPlanUser(user);
}

export function openCreatorPlanUpgradeDialog(
  dialog: MatDialog,
  returnUrl?: string | null
): void {
  const data: UpgradePlanDialogData = {
    returnUrl: returnUrl || undefined,
    feature: "creator-publish-access",
  };

  dialog.open(UpgradePlanDialogComponent, {
    width: "780px",
    maxWidth: "100vw",
    maxHeight: "100vh",
    panelClass: "upgrade-plan-dialog-pane",
    autoFocus: false,
    restoreFocus: false,
    data,
  });
}
